module.exports = __webpack_public_path__ + "img/plan-s1.42e1f8bb.svg";